import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AssessmentProvider } from './context/AssessmentContext';
import GlobalStyles from './styles/GlobalStyles';

// "ResizeObserver loop completed with undelivered notifications" is a benign
// browser quirk (a resize triggered a layout change before the next frame).
// webpack-dev-server's overlay treats it as a fatal error; suppress it.
if (typeof window !== 'undefined') {
    window.addEventListener('error', (e) => {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            e.stopImmediatePropagation();
        }
    });
}

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <GlobalStyles />
    <AssessmentProvider>
      <App />
    </AssessmentProvider>
  </React.StrictMode>
);